import { styled } from '@moleculeone/ui';

import { ReagentTag } from './ReagentTag';
import { ConditionCompoundPreview } from './ConditionCompoundPreview';

const GroupConditionName = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '$2',
  fontSize: '$1',
  fontWeight: 500,
  textTransform: 'uppercase',
  color: '$slate9',
  letterSpacing: '.05em',
  marginBottom: '$2',
});

type GroupConditionProps = {
  name: string;
  value: {
    full_name: string;
    smiles?: string;
  };
};

export function GroupCondition(props: GroupConditionProps) {
  const { name, value } = props;

  return (
    <div>
      <GroupConditionName>
        {name}:
        <ReagentTag key={name} condition={name} text={value.full_name} fullWidth={true} />
      </GroupConditionName>

      {value.smiles && <ConditionCompoundPreview item={value} />}
    </div>
  );
}
